import { MODAL_HEIGHT, MODAL_WIDTH, appConfig } from "@/constants";
import { ConfirmationDialog, Stack } from "@biom3/react";
import Image from "next/image";

export type TelegramQuestModalContentProps = {
  title: string;
  caption?: string | null;
  button?: string | null;
  action?: (() => void) | null;
  showClose: boolean;
  onClose: () => void;
  showLinkAccountImages: boolean;
};

export const TelegramQuestModalContent = ({
  title,
  caption,
  button,
  action,
  showClose,
  onClose,
  showLinkAccountImages,
}: TelegramQuestModalContentProps) => {
  return (
    <ConfirmationDialog visible>
      <ConfirmationDialog.Content
        sx={{
          d: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: "base.borderRadius.x10",
          position: "relative",
          overflow: "hidden",
          background: "base.color.brand.2",
          backgroundImage: `url("${appConfig.ASSET_BASE_URL}/images/quests/follow-confirmation-background.svg")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
          height: MODAL_HEIGHT,
          width: {
            default: "calc(100dvw - 40px)",
            small: MODAL_WIDTH,
          },
        }}
      >
        <ConfirmationDialog.Content.Image
          use={
            showLinkAccountImages ? (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                gap="base.spacing.x4"
                sx={{
                  marginTop: "64px",
                  marginBottom: "64px",
                }}
              >
                <Image
                  src="/images/quests/telegram-logo.svg"
                  width="64"
                  height="64"
                  alt="Telegram Logo"
                  style={{
                    objectFit: "contain",
                    padding: "4px",
                  }}
                />
                <Image
                  id="double-sided-arrow"
                  src="/images/quests/double-sided-arrow.svg"
                  alt="Double sided arrow"
                  width={26}
                  height={8}
                />
                <Image
                  src="/images/quests/immutable-logo.svg"
                  width="64"
                  height="64"
                  alt="Telegram Logo"
                  style={{
                    objectFit: "contain",
                    padding: "4px",
                  }}
                />
              </Stack>
            ) : (
              <Image
                src="/images/quests/telegram-logo.svg"
                width="64"
                height="64"
                alt="Telegram Logo"
                style={{
                  objectFit: "contain",
                  marginTop: "128px",
                  marginBottom: "128px",
                }}
              />
            )
          }
        />
        <ConfirmationDialog.Content.Title>
          {title}
        </ConfirmationDialog.Content.Title>
        {caption && (
          <ConfirmationDialog.Content.Caption>
            {caption}
          </ConfirmationDialog.Content.Caption>
        )}
        {button && action && (
          <ConfirmationDialog.Content.Button size="large" onClick={action}>
            {button}
          </ConfirmationDialog.Content.Button>
        )}
        {showClose && (
          <ConfirmationDialog.Content.CloseButtCon onClick={onClose} />
        )}
      </ConfirmationDialog.Content>
    </ConfirmationDialog>
  );
};
